document.addEventListener('DOMContentLoaded', () => {
  class GenderSwitch extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.gender-switch__button');
      this.defaultGender = this.dataset.defaultGender || 'women';
      this.womenLink = this.dataset.womenLink || '/';
      this.menLink = this.dataset.menLink || '/';

      // Colors
      this.activeBg = this.dataset.activeBg || '#000000';
      this.activeText = this.dataset.activeText || '#ffffff';
      this.hoverBg = this.dataset.hoverBg || '#f0f0f0';

      // Apply CSS variables
      this.style.setProperty('--active-bg', this.activeBg);
      this.style.setProperty('--active-text', this.activeText);
      this.style.setProperty('--hover-bg', this.hoverBg);

      this.init();
    }

    init() {
      let gender = this.defaultGender;

      // Auto-activate men if URL contains "for-him"
      const path = window.location.pathname.toLowerCase();
      if (path.includes('men')) gender = 'men';

      this.setActive(gender);

      // Attach click events
      this.buttons.forEach(btn => {
        btn.addEventListener('click', e => {
          const newGender = btn.dataset.gender;
          this.setActive(newGender);
          const link = btn.dataset.link;
          if (link) window.location.href = link;
        });
      });
    }

    setActive(gender) {
      this.buttons.forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.gender === gender);
      });
    }
  }

  if (!customElements.get('gender-switch')) {
    customElements.define('gender-switch', GenderSwitch);
  }
});
